import { useState } from "react";
import { BellRing, Loader2 } from "lucide-react";
import { toast } from "sonner";
import { sendTestPush } from "../lib/api";

async function currentEndpoint() {
  if (!("serviceWorker" in navigator)) return null;
  const reg = await navigator.serviceWorker.getRegistration();
  const sub = reg && (await reg.pushManager.getSubscription());
  return sub?.endpoint || null;
}

export function reportTestResult(res) {
  if (res.sent > 0) {
    toast.success(`Test alert sent to ${res.sent} phone${res.sent > 1 ? "s" : ""} — it should ring within a few seconds. No sound? Check the phone isn't on silent / Do Not Disturb, and Chrome notifications for this site are allowed with sound.`, { duration: 9000 });
  } else {
    toast.error(`Test alert failed: ${(res.errors || []).join("; ") || "no phones reached"}`, { duration: 9000 });
  }
}

// Driver: sends a REAL push to this phone via the push service (same path
// as job alerts), so it proves delivery + the phone's own alert sound.
export default function PushTestButton({ ensureSubscribed }) {
  const [busy, setBusy] = useState(false);
  async function run() {
    setBusy(true);
    try {
      let endpoint = await currentEndpoint();
      if (!endpoint) {
        await ensureSubscribed();
        endpoint = await currentEndpoint();
      }
      if (!endpoint) {
        toast.error("This phone isn't signed up for job alerts — allow notifications for this site, then try again.");
        return;
      }
      reportTestResult(await sendTestPush({ endpoint }));
    } catch (e) {
      toast.error(e?.response?.data?.detail || "Couldn't send test alert — check your signal and try again.");
    } finally {
      setBusy(false);
    }
  }
  return (
    <button
      onClick={run}
      disabled={busy}
      className="flex-1 justify-center text-sm font-semibold px-2.5 sm:px-4 py-2 sm:py-2.5 rounded-md inline-flex items-center gap-1.5 sm:gap-2 bg-slate-800 hover:bg-slate-700 text-slate-100 transition-colors disabled:opacity-60"
      data-testid="driver-push-test-btn"
      title="Send a test job alert to this phone"
      aria-label="Send test alert"
    >
      {busy ? <Loader2 className="h-4 w-4 animate-spin" /> : <BellRing className="h-4 w-4 text-emerald-400" />}
      <span className="hidden sm:inline">Test alert</span>
    </button>
  );
}
